import React from 'react';
export default (
  <svg width="33px" height="32px" viewBox="0 0 33 32">
    <g
      stroke="#ADB5BD"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        d="M3,0 L22.3888889,0 L22.3888889,0 L31,8.90234375 L31,27 C31,28.6568542 29.6568542,30 28,30 L3,30 C1.34314575,30 2.02906125e-16,28.6568542 0,27 L0,3 C-2.02906125e-16,1.34314575 1.34314575,3.04359188e-16 3,0 Z"
        strokeWidth={1.71428571}
        transform="translate(1 1)"
      />
      <path
        strokeWidth={1.71}
        d="M21.5 3.5L21.5 10.5 27.4444444 10.5M5.5 10L15.5 10M5.5 5L15.5 5M5.5 20L25.5 20M5.5 25L25.5 25M5.5 15L25.5 15"
        transform="translate(1 1)"
      />
    </g>
  </svg>
);
